interface LogoProps {
  variant?: 'light' | 'dark';
}

export default function Logo({ variant = 'light' }: LogoProps) {
  const textColor = variant === 'light' ? 'text-background-50' : 'text-foreground-950';
  const subTextColor = variant === 'light' ? 'text-background-200/80' : 'text-foreground-500';

  return (
    <a href="/" className="flex items-center gap-3 group cursor-pointer">
      <div className="relative w-9 h-9 flex items-center justify-center">
        <div className="absolute inset-0 flex items-center justify-center transition-transform duration-500 group-hover:rotate-45">
          <div
            className="w-8 h-8 bg-primary-500"
            style={{
              clipPath: 'polygon(50% 0%, 100% 100%, 0% 100%)',
            }}
          />
        </div>
      </div>
      <div className="flex flex-col leading-none">
        <span className={`font-heading font-bold text-lg tracking-tight ${textColor}`}>
          Angle Forty
        </span>
        <span className={`font-mono-tech text-[10px] tracking-[0.3em] mt-1 ${subTextColor}`}>
          銳角40
        </span>
      </div>
    </a>
  );
}